/*
  Some mapbox types can be too complex and result in the error,
    "type instantiation too deep and possibly infinite",
    when nested inside our own types/interfaces.
  These simplified interfaces solve the issue in most cases.
  When even these interfaces aren't simple enough,
    'any' can be used within our interfaces instead
    until a different resolution can be found.
*/
import { z } from 'zod';
/*
From mapbox package, ExpressionSpecification defined as:
  type ExpressionSpecification = [
    string,
    ...any[]
  ]

Re-write as zod schema for use in our other zod schemas (LayerValues)
*/
export const ExpressionSpecificationSchema = z.tuple([z.string()]).rest(z.any());
//# sourceMappingURL=mapbox.js.map